import React, { useState, useEffect } from "react";
import "./Home.css";
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const Home = () => {
  const [username, setUsername] = useState("User");
  const [stats, setStats] = useState({
    workouts: 0,
    calories: 0,
    minutes: 0,
    streak: 0
  });
  
  // Mock data - in real app, this would come from API
  const activityData = [
    { name: 'Mon', Running: 30, Cycling: 0, Weightlifting: 45 },
    { name: 'Tue', Running: 20, Cycling: 45, Weightlifting: 30 },
    { name: 'Wed', Running: 0, Cycling: 60, Weightlifting: 0 },
    { name: 'Thu', Running: 45, Cycling: 0, Weightlifting: 60 },
    { name: 'Fri', Running: 20, Cycling: 30, Weightlifting: 0 },
    { name: 'Sat', Running: 60, Cycling: 45, Weightlifting: 0 },
    { name: 'Sun', Running: 0, Cycling: 0, Weightlifting: 90 },
  ];

  const goals = [
    { id: 1, title: "Run 5K", progress: 75, target: "3 times per week" },
    { id: 2, title: "Cycling", progress: 45, target: "50 miles weekly" },
    { id: 3, title: "Weight Training", progress: 60, target: "4 sessions per week" }
  ];

  const tips = [
    "Try to include at least 30 minutes of cardio in your routine.",
    "Remember to hydrate before, during, and after workouts.",
    "Rest days are as important as workout days for muscle recovery.",
    "Consider mixing high and low intensity workouts throughout the week."
  ];

  // Simulating data fetch
  useEffect(() => {
    // This would be an API call in a real application
    const user = localStorage.getItem("user");
    if (user) {
      const userData = JSON.parse(user);
      setUsername(userData.email.split('@')[0]);
    }
    
    // Mock stats
    setStats({
      workouts: 12,
      calories: 4200,
      minutes: 320,
      streak: 5
    });
  }, []);

  return (
    <div className="home-container">
      <div className="welcome-section">
        <div className="welcome-content">
          <h1>Welcome back, {username}!</h1>
          <p>Track your fitness journey, set goals, and watch your progress grow.</p>
        </div>
      </div>

      <div className="dashboard-grid">
        {/* Stats Section */}
        <div className="dashboard-card stats-card">
          <h2>Activity Summary</h2>
          <div className="stats-grid">
            <div className="stat-item">
              <span className="stat-value">{stats.workouts}</span>
              <span className="stat-label">Workouts</span>
            </div>
            <div className="stat-item">
              <span className="stat-value">{stats.calories}</span>
              <span className="stat-label">Calories</span>
            </div>
            <div className="stat-item">
              <span className="stat-value">{stats.minutes}</span>
              <span className="stat-label">Minutes</span>
            </div>
            <div className="stat-item">
              <span className="stat-value">{stats.streak}</span>
              <span className="stat-label">Day Streak</span>
            </div>
          </div>
        </div>

        {/* Progress Chart */}
        <div className="dashboard-card chart-card">
          <h2>Weekly Activity</h2>
          <div className="chart-container">
            <ResponsiveContainer width="100%" height={250}>
              <LineChart data={activityData}>
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis label={{ value: 'Minutes', angle: -90, position: 'insideLeft' }} />
                <Tooltip />
                <Legend />
                <Line type="monotone" dataKey="Running" stroke="#FF5733" activeDot={{ r: 8 }} />
                <Line type="monotone" dataKey="Cycling" stroke="#33A1FF" />
                <Line type="monotone" dataKey="Weightlifting" stroke="#33FF57" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>

        {/* Goals Section */}
        <div className="dashboard-card goals-card">
          <h2>Your Fitness Goals</h2>
          <div className="goals-list">
            {goals.map(goal => (
              <div className="goal-item" key={goal.id}>
                <div className="goal-header">
                  <h3>{goal.title}</h3>
                  <span>{goal.target}</span>
                </div>
                <div className="goal-progress">
                  <div className="progress-bar">
                    <div className="progress-fill" style={{ width: `${goal.progress}%` }}></div>
                  </div>
                  <span className="progress-text">{goal.progress}%</span>
                </div>
              </div>
            ))}
          </div>
          <button className="add-goal-btn">Set New Goal</button>
        </div>

        {/* Tips Section */}
        <div className="dashboard-card tips-card">
          <h2>Fitness Tips</h2>
          <div className="tips-list">
            {tips.map((tip, index) => (
              <div className="tip-item" key={index}>
                <div className="tip-number">{index + 1}</div>
                <p>{tip}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Quick Actions */}
      <div className="quick-actions">
        <button className="action-btn primary">Log Workout</button>
        <button className="action-btn secondary">View Progress</button>
        <button className="action-btn secondary">Update Goals</button>
      </div>
    </div>
  );
};

export default Home;